import { TFunction } from '_metronic/i18n/Metronici18n'
import { IOption } from 'app/components'
import { getFornecedores } from '../../fornecedores/core/_requests'
import { buscaFornecedores } from '../../fornecedores/core/buscaFornecedores'
import { getTelekits } from '../../telekits/telekits-list/core/_requests'
import { TelekitList } from '../../telekits/telekits-list/core/_models'
import { DispositivoGestaoList } from './_models'
import { getDispositivosGestao } from './_requests'
import { rotuloMaleta, rotuloTipo } from './rotulos'
import { criterioTextoLivre } from './buscaDsl'
import { CAMPOS_TEXTO_DISPOSITIVO } from '../dispositivos-list/core/ListFiltersProvider'

type Pagina<T> = { options: IOption<T>[]; hasMore: boolean }

/** Fornecedores para select assíncrono (`apenasAtivos` filtra o combo do cadastro). */
export const buscaOpcoesFornecedores =
  (apenasAtivos: boolean) =>
  async (texto: string, _todos: boolean, _extra?: Object, page = 0): Promise<Pagina<number>> => {
    const search = buscaFornecedores({ texto, ativo: apenasAtivos ? true : undefined })
    const filtros = [
      `page=${page}`,
      'size=20',
      'sort=nome,asc',
      search ? `search=${encodeURIComponent(search)}` : '',
    ]
    const resposta = await getFornecedores(filtros.filter(Boolean).join('&'))
    return {
      options: (resposta.data ?? []).map((f) => ({ value: f.id, label: f.nomeFantasia || f.nome })),
      hasMore: !resposta.last,
    }
  }

export const rotuloTelekitOpcao = (t: TFunction, telekit: TelekitList) =>
  telekit.padrao
    ? rotuloMaleta(t, { padrao: true })
    : t('dispositivos.rotulos.maleta_telekit_empresa', {
        identificador: telekit.identificador ?? '',
        empresa: telekit.empresa?.nomeFantasia ?? '',
      })

/** Maletas para o filtro da lista; o texto digitado busca pelo identificador numérico. */
export const buscaOpcoesMaletas =
  (t: TFunction) =>
  async (texto: string, _todos: boolean, _extra?: Object, page = 0): Promise<Pagina<number>> => {
    const numero = texto.replace(/\D/g, '')
    const filtros = [
      `page=${page}`,
      'size=20',
      'sort=identificador,asc',
      numero ? `search=identificador:${numero}` : '',
    ]
    const resposta = await getTelekits(filtros.filter(Boolean).join('&'))
    return {
      options: (resposta.data ?? []).map((k) => ({ value: k.id, label: rotuloTelekitOpcao(t, k) })),
      hasMore: !resposta.last,
    }
  }

export type OpcaoDispositivo = IOption<number> & { dispositivo: DispositivoGestaoList }

export const rotuloDispositivoOpcao = (t: TFunction, d: DispositivoGestaoList) =>
  t('pagina.telekits.dispositivos.opcao_dispositivo', {
    tipo: rotuloTipo(t, d.tipo),
    serie: d.serie,
    empresa: d.empresa?.nome ?? '',
  }) + (d.regime === 'VENDIDO' ? ` · ${t('dispositivos.rotulos.regime.VENDIDO')}` : '')

/** Dispositivos que podem ser alocados (fora de Em uso, Baixado e Extraviado). */
export const buscaOpcoesDispositivosAlocaveis =
  (t: TFunction) =>
  async (
    texto: string,
    _todos: boolean,
    _extra?: Object,
    page = 0
  ): Promise<{ options: OpcaoDispositivo[]; hasMore: boolean }> => {
    const search = criterioTextoLivre(CAMPOS_TEXTO_DISPOSITIVO, texto)
    const filtros = [
      'alocavel=true',
      `page=${page}`,
      'size=20',
      search ? `search=${encodeURIComponent(search)}` : '',
    ]
    const resposta = await getDispositivosGestao(filtros.filter(Boolean).join('&'))
    return {
      options: (resposta.data ?? []).map((d) => ({
        value: d.id,
        label: rotuloDispositivoOpcao(t, d),
        dispositivo: d,
      })),
      hasMore: !resposta.last,
    }
  }
